import { QueryHookOptions, QueryResult, useQuery } from '@apollo/client';
import { gql } from '__generated__/gql';
import { useDefaultOnError } from 'hooks/useDefaultOnError';

const IS_LOGGED_IN_QUERY = gql(/* GraphQL */ `
  query isLoggedInQuery {
    isLoggedIn
  }
`);

interface IsLoggedInQueryData {
  isLoggedIn: boolean;
}

export function useIsLoggedInQuery(options?: QueryHookOptions<IsLoggedInQueryData>): QueryResult<IsLoggedInQueryData> {
  const onError = useDefaultOnError();
  return useQuery<IsLoggedInQueryData>(IS_LOGGED_IN_QUERY, {
    ...options,
    onError,
  });
}
